import { z } from 'zod'

export const K8sUsageSummary = z.object({
  cpu_core_hours: z.number(),
  memory_gib_hours: z.number(),
  storage_gib: z.number(),
  egress_gib: z.number(),
  period_start: z.number(),
  period_end: z.number()
})
export type K8sUsageSummary = z.infer<typeof K8sUsageSummary>

export const K8sProjectedBill = z.object({
  cpu_cents: z.number(),
  memory_cents: z.number(),
  storage_cents: z.number(),
  egress_cents: z.number(),
  base_fee_cents: z.number(),
  total_cents: z.number(),
  days_in_period: z.number(),
  days_elapsed: z.number(),
  // floor_cents is base fee + storage, i.e. what the period costs if every
  // workload sleeps from here on. NET, like every other amount here.
  // Optional because the frontend and backend deploy independently: a
  // required field would make a single older backend blank the whole bill.
  floor_cents: z.number().optional(),
  low_confidence: z.boolean().optional()
})
export type K8sProjectedBill = z.infer<typeof K8sProjectedBill>

export const K8sSpendingCap = z.object({
  spending_cap_cents: z.number().nullable()
})
export type K8sSpendingCap = z.infer<typeof K8sSpendingCap>

export const K8sUsageHistoryPoint = z.object({
  date: z.string(),
  cpu_core_hours: z.number(),
  memory_gib_hours: z.number(),
  storage_gib: z.number(),
  cost_cents: z.number()
})
export type K8sUsageHistoryPoint = z.infer<typeof K8sUsageHistoryPoint>

// Scale-to-zero. available === false means the namespace is not wired up for
// the feature yet, and the panel renders nothing at all. It must never read
// as "nothing is asleep". hourly_cents_when_awake is NET.
export const K8sSleepingWorkload = z.object({
  name: z.string(),
  kind: z.string(),
  route: z.string(),
  asleep: z.boolean(),
  replicas: z.number(),
  hourly_cents_when_awake: z.number()
})
export type K8sSleepingWorkload = z.infer<typeof K8sSleepingWorkload>

export const K8sSleepStatus = z.object({
  available: z.boolean(),
  workloads: z.array(K8sSleepingWorkload)
})
export type K8sSleepStatus = z.infer<typeof K8sSleepStatus>

export const K8sPodLogs = z.object({
  logs: z.string()
})
export type K8sPodLogs = z.infer<typeof K8sPodLogs>
